import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, ViewEncapsulation, inject } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
export interface IPageComponentIframeData extends NICmsContentComponent.IData {
    link?: string;
}
@ICmsComponent<PageComponentIframeComponent>({
    id: 'iframe',
    name: 'IFrame',
    isAdvanced: false,
    fields: [
        {
            type: NICmsContentField.EFieldType.text,
            key: 'link',
            title: 'Link',
            default: '/'
        }
    ]
})
@Component({
    selector: 'page-component-iframe',
    templateUrl: './iframe.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [CommonModule, ICmsClientModule]
})
export class PageComponentIframeComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'component'
    })
    component!: IPageComponentIframeData;

    private domSanitizer = inject(DomSanitizer);

    get url() {
        return this.domSanitizer.bypassSecurityTrustResourceUrl(<string>this.component.link);
    }
}
